import React, { useEffect, useState } from "react";
import { PlayCircle, Video } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Card } from "@/components/ui/card";
import { api, API } from "@/lib/api";

export function WelcomeVideo() {
  const { t } = useLanguage();
  const [video, setVideo] = useState(null);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    api.get("/welcome-video").then(({ data }) => setVideo(data)).catch(() => {});
  }, []);

  if (!video) return null;
  const src = `${API}${video.streamUrl}`;

  return (
    <Card className="premium-card overflow-hidden p-0">
      <div className="grid gap-0 md:grid-cols-[1fr_1.1fr]">
        <div className="flex flex-col justify-center gap-3 p-6">
          <span className="tech-label inline-flex items-center gap-2 text-accent"><Video className="h-3.5 w-3.5" />{t("client.video.badge")}</span>
          <h3 className="font-serif text-xl font-semibold text-foreground">{video.title || t("client.video.title")}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">{t("client.video.subtitle")}</p>
        </div>
        <div className="relative min-h-[220px] bg-sidebar">
          {play ? (
            <video src={src} controls autoPlay className="h-full w-full object-cover">{t("client.video.unsupported")}</video>
          ) : (
            <button type="button" onClick={() => setPlay(true)} className="group flex h-full w-full items-center justify-center">
              <span className="flex flex-col items-center gap-2 text-sidebar-foreground">
                <PlayCircle className="h-14 w-14 text-sidebar-primary transition-transform duration-300 group-hover:scale-110" />
                <span className="text-sm font-medium">{t("client.video.watch")}</span>
              </span>
            </button>
          )}
        </div>
      </div>
    </Card>
  );
}
